import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { DataProvider } from './hooks/useDataContext.js';

const rootElements = document.querySelectorAll('.wp-block-gravity-episode-player-app');

rootElements.forEach((element) => {
    const title = element.getAttribute('data-title');
    const audioURL = element.getAttribute('data-audioURL');
    const description = element.getAttribute('data-description');
    const imageURL = element.getAttribute('data-imageURL');
    const dataSource = element.getAttribute('data-source');
    const dataDynamic = element.getAttribute('data-dynamic');
    const pageId = element.getAttribute('data-pageId');
    const url = element.getAttribute('data-url');
    const apiUrl = `${url}nwm/v1/${dataDynamic}`;
    const episodeSlug = element.getAttribute('data-episodeSlug');
    const embedId = element.getAttribute('data-embedid');
    const postsCount = element.getAttribute('data-postsCount');
    const postsPerView = element.getAttribute('data-postsperview');

    ReactDOM.render(
        <React.StrictMode>
            <DataProvider>
                <App
                    title={title}
                    audioURL={audioURL}
                    description={description}
                    imageURL={imageURL}
                    source={dataSource}
                    dataDynamic={dataDynamic}
                    apiUrl={apiUrl}
                    pageId={pageId}
                    episodeSlug={episodeSlug}
                    embedId={embedId}
                    postsCount={postsCount}
                    postsPerView={postsPerView}
                />
            </DataProvider>
        </React.StrictMode>,
        element
    );
});

function unmountPlayers() {
    rootElements.forEach((element) => {
        ReactDOM.unmountComponentAtNode(element);
    });
}
document.addEventListener('csr_before_page_change', unmountPlayers, { once: true });
